export default "a-default";
export const aNamed = "a-named";



// WEBPACK FOOTER //
// ./src/mod4.js